import styled from "@emotion/styled";
import { Button, Option, Select, Text, Variables } from "@repo/skapa";
import { T, t } from "@repo/translation";
import { FlexDiv } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

const PaginationRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Variables.space75};
  padding: ${Variables.space100} 0;
`;

const PAGE_SIZE_OPTIONS = [10, 25, 50];

interface PaginationProps {
  currentNumber: number;
  totalNumber: number;
  setSize: (size: number) => void;
  size: number;
  pageSize?: number;
  onPageSizeChange?: (pageSize: number) => void;
}

export const Pagination = ({
  currentNumber,
  totalNumber,
  size,
  setSize,
  pageSize,
  onPageSizeChange,
}: PaginationProps) => {
  return (
    <PaginationRow>
      <FlexDiv alignItems="center" gap={Variables.space150}>
        {onPageSizeChange && pageSize !== undefined && (
          <FlexDiv alignItems="center" gap={Variables.space50}>
            <Text textStyle="Body.M">{t("label.projects_per_page")}</Text>
            <FlexDiv width="80px">
              <Select
                required
                id="page-size-select"
                value={String(pageSize)}
                defaultValue={String(PAGE_SIZE_OPTIONS[0])}
                onChange={(e) => onPageSizeChange(Number(e.target.value))}
              >
                {PAGE_SIZE_OPTIONS.map((option) => (
                  <Option
                    key={option}
                    value={String(option)}
                    name={String(option)}
                  />
                ))}
              </Select>
            </FlexDiv>
          </FlexDiv>
        )}
        {currentNumber < totalNumber && (
          <Button
            type="secondary"
            text={t("action.show_more")}
            onClick={() => {
              setSize(size + 1);
              trackAnalytics("show_more_pages");
            }}
          />
        )}
      </FlexDiv>
      <Text textStyle="Body.M">
        <T
          translationKey="action.show_result"
          values={{
            currentNumber: currentNumber ?? 0,
            totalNumber: totalNumber ?? 0,
          }}
        />
      </Text>
    </PaginationRow>
  );
};

export const CompactPagination = ({
  currentNumber,
  totalNumber,
  size,
  setSize,
}: PaginationProps) => {
  return (
    <FlexDiv alignItems="center" justifyContent="space-between">
      <Text textStyle="Body.S">
        <T
          translationKey="action.show_result"
          values={{
            currentNumber: currentNumber ?? 0,
            totalNumber: totalNumber ?? 0,
          }}
        />
      </Text>
      {currentNumber < totalNumber && (
        <Button
          size="small"
          type="secondary"
          text={t("action.show_more")}
          onClick={() => {
            setSize(size + 1);
            trackAnalytics("show_more_pages");
          }}
        />
      )}
    </FlexDiv>
  );
};
